<template>
  <div class="container-header no-print">
    <div class="content-header">
      <span class="title-header">{{ title }}</span>
      <div class="content-header-time-buttons" v-if="!disableButtons">
        <button
          v-for="button in buttons"
          v-if="button.visible"
          :key="button.id"
          :class="['header-time-buttons', { selected: selectedButtonId === button.id }]"
          :disabled="isLoadingPredictionTraffic || isLoadingPredictionInteractiveMap"
          @click="handleButtonClick(button.id)"
        >
          {{ button.label }}
        </button>
      </div>
    </div>
    <div class="content-header" v-if="showFiltersAndExportButton">
      <div class="search-container">
        <button class="filter-button" @click="visibleFilterRight = true">
          <i class="fa-solid fa-filter" />
        </button>
      </div>
      <div class="data-container">
        <button class="config-button" @click="visibleRight = true">
          <i class="fa-solid fa-sliders" />
        </button>
        <button class="export-button-header" @click="visibleExportDataRight = true">
          <i class="fa-solid fa-download" />
          Exportar Dados
        </button>
      </div>
    </div>
    <div class="custom-header-block-pills" v-if="selectedButtonId === 3">
      <div
        v-for="pill in pillLabels"
        v-if="pill.enabled"
        class="custom-header-pill"
        :key="pill.days"
        :class="{
          active: activePill === pill.days,
          loading: isLoadingPredictionTraffic || isLoadingPredictionInteractiveMap,
        }"
        @click="handlePrediction(pill.days)"
      >
        {{ pill.label }}
      </div>
    </div>
    <div class="header-content-title-time">
      <span class="header-title-time">{{ subtitleData }} </span>
    </div>
    <Sidebar
      :visible.sync="visibleRight"
      :base-z-index="1000"
      position="right"
      class="w-full md:w-60rem lg:w-70rem"
    >
      <span class="sidebar-title">Personalizar Painel</span>
      <DataTable :value="components" responsive-layout="scroll" style="margin-top: 30px">
        <Column field="field" header="Indicador" />
        <Column header="Habilitar" field="enabled">
          <template #body="rowData">
            <InputSwitch :value="rowData.data.enabled" @change="toggleComponent(rowData.data.id)" />
          </template>
        </Column>
      </DataTable>
    </Sidebar>
    <Sidebar
      :visible.sync="visibleExportDataRight"
      :base-z-index="1000"
      position="right"
      class="w-full md:w-60rem lg:w-70rem"
    >
      <span class="sidebar-title">Exportar</span>
      <DataTable :value="componentsForPrint" responsive-layout="scroll" style="margin-top: 30px">
        <Column field="field" header="Dados" />
        <Column header="Habilitar" field="print">
          <template #body="rowData">
            <InputSwitch
              :value="rowData.data.print"
              @change="toggleComponentForPrint(rowData.data.id)"
            />
          </template>
        </Column>
      </DataTable>
      <div class="content-buttons-sidebar-filter">
        <button class="sidebar-save-button" @click="generatePDF">Exportar como PDF</button>
      </div>
    </Sidebar>
    <Sidebar
      :visible.sync="visibleFilterRight"
      :base-z-index="1000"
      position="right"
      class="w-full md:w-60rem lg:w-70rem sidebar-custom"
    >
      <div class="sidebar-filter-content">
        <span class="sidebar-title">Filtrar</span>

        <div class="content-chips-sidebar">
          <CustomChip
            v-for="chip in chips"
            :key="chip.days"
            :text="chip.label"
            :is-active="chip.days === selectedDays"
            @click="handTimeForPastRequest(chip.days)"
          />
        </div>
      </div>

      <div class="content-buttons-sidebar-filter">
        <button class="sidebar-save-button" @click="handleButtonClick(1)">Aplicar filtros</button>
        <button class="sidebar-cancel-button" @click="visibleFilterRight = false">Cancelar</button>
      </div>
    </Sidebar>
    <Toast style="z-index: 9999" />
  </div>
</template>

<script>
import Layout from '../Layout.vue'
import { mapState } from 'pinia'
import Sidebar from 'primevue/sidebar'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputSwitch from 'primevue/inputswitch'
import Toast from 'primevue/toast'
import CustomChip from './Components/CustomChip.vue'
import { useTransportModes } from '../../../stores/transportModes'
import { useCustomHeader } from '../../../stores/customHeader'
export default {
  components: {
    Sidebar,
    DataTable,
    Column,
    InputSwitch,
    Toast,
    CustomChip,
  },
  layout: Layout,
  props: {
    title: String,
    subtitle: {
      type: String,
      required: false,
      default: () => 'Dados em tempo real',
    },
    showFiltersAndExportButton: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    fectchRealTime: Function,
    fectchPastTime: Function,
    searchInputHeader: Function,
    generatePDF: Function,
    prediction: Function,
    buttons: {
      type: Array,
      required: false,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => [
        { id: 1, label: 'Passado', visible: true },
        { id: 2, label: 'Tempo Real', visible: true },
        { id: 3, label: 'Previsão', visible: false },
      ],
    },
    pillLabels: {
      type: Array,
      required: false,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => [
        { label: 'Pŕoximos 7 dias', days: 7, enabled: true },
        { label: 'Pŕoximos 15 dias', days: 15, enabled: true },
        { label: 'Pŕoximos 30 dias', days: 30, enabled: true },
        { label: 'Pŕoximos 6 meses', days: 180, enabled: true },
      ],
    },
  },
  data() {
    return {
      visibleRight: false,
      visibleFilterRight: false,
      visibleExportDataRight: false,
      components: this.loadComponents(),
      componentsForPrint: this.loadComponentsForPrint(),
      timeForstPastRequest: 180,
      selectedDays: null,
      chips: [
        { label: '7 dias', days: 7 },
        { label: '15 dias', days: 15 },
        { label: '30 dias', days: 30 },
        { label: 'Trimestre', days: 90 },
        { label: 'Semestre', days: 180 },
        { label: 'Ano', days: 365 },
      ],
      activePill: 0,
      subtitleData: this.subtitle,
    }
  },
  computed: {
    ...mapState(useCustomHeader, ['isLoadingPredictionTraffic']),
    ...mapState(useCustomHeader, ['isLoadingPredictionInteractiveMap']),
    ...mapState(useCustomHeader, ['selectedButtonId']),
    ...mapState(useCustomHeader, ['getSelectedButtonId']),
    ...mapState(useCustomHeader, ['disableButtons']),
  },
  mounted() {
    this.loadComponents()
    this.loadComponentsForPrint()
  },
  methods: {
    handlePrediction(days) {
      this.activePill = days
      this.prediction(days)
    },
    loadComponents() {
      if (window.location.pathname === '/transport-modes/profile') {
        const transportModes = useTransportModes()
        this.components = transportModes.components
      }
      if (window.location.pathname === '/transport-modes') {
        const transportModes = useTransportModes()
        this.components = transportModes.components
      }
      if (window.location.pathname === '/transport-modes/economic-performance') {
        const transportModes = useTransportModes()
        this.components = transportModes.componentsEconomicPerformance
      }
    },
    loadComponentsForPrint() {
      if (window.location.pathname === '/transport-modes/profile') {
        const componentsForPrint = useTransportModes()
        this.componentsForPrint = componentsForPrint.componentsForPrint
      }
      if (window.location.pathname === '/transport-modes/economic-performance') {
        const componentsForPrint = useTransportModes()
        this.componentsForPrint = componentsForPrint.componentsEconomicPerformanceForPrint
      }
    },
    handTimeForPastRequest(days) {
      this.selectedDays = days
      this.timeForstPastRequest = days
    },
    handleSubtitle() {
      switch (this.timeForstPastRequest) {
        case 7:
          this.subtitleData = 'Dados dos últimos 7 dias'
          break
        case 15:
          this.subtitleData = 'Dados dos últimos 15 dias'
          break
        case 30:
          this.subtitleData = 'Dados dos últimos 30 dias'
          break
        case 90:
          this.subtitleData = 'Dados dos últimos 3 meses'
          break
        case 180:
          this.subtitleData = 'Dados dos últimos 6 meses'
          break
        case 365:
          this.subtitleData = 'Dados dos últimos 1 ano'
          break
        default:
          this.subtitleData = 'Dados dos últimos 6 meses'
          break
      }
    },
    handleButtonClick(id) {
      this.selectButton(id)
      switch (id) {
        case 1:
          this.handleSubtitle()
          this.visibleFilterRight = false
          this.fectchPastTime(this.timeForstPastRequest)
          break
        case 2:
          this.subtitleData = 'Dados em tempo real'
          this.fectchRealTime()
          break
        case 3:
          this.subtitleData = 'Previsão'
      }
    },
    selectButton(id) {
      this.getSelectedButtonId(id)
    },
    // Método para alterar o estado de um componente
    toggleComponent(id) {
      if (window.location.pathname === '/transport-modes/profile') {
        const transportModes = useTransportModes()
        const component = transportModes.components.find((comp) => comp.id === id)
        transportModes.getCurrentComponente = component
        if (component) {
          component.enabled ? this.disableComponent(id) : this.enableComponent(id)
        }
        this.saveChanges()
      }

      if (window.location.pathname === '/transport-modes/economic-performance') {
        console.log('id')
        console.log(id)
        const transportModes = useTransportModes()
        const component = transportModes.componentsEconomicPerformance.find(
          (comp) => comp.id === id,
        )
        transportModes.getCurrentComponentsEconomicPerformance = component
        if (component) {
          component.enabled ? this.disableComponent(id) : this.enableComponent(id)
        }
        this.saveChanges()
      }
    },
    toggleComponentForPrint(id) {
      if (window.location.pathname === '/transport-modes/profile') {
        const transportModes = useTransportModes()
        transportModes.componentsForPrint.map((comp) => {
          if (comp.id === id) {
            comp.print = !comp.print
          }
        })
      }
      if (window.location.pathname === '/transport-modes/economic-performance') {
        const transportModes = useTransportModes()
        transportModes.componentsEconomicPerformanceForPrint.map((comp) => {
          if (comp.id === id) {
            comp.print = !comp.print
          }
        })
      }
    },
    enableComponent(id) {
      const component = this.components.find((comp) => comp.id === id)
      if (component) {
        component.enabled = true
      }
    },
    disableComponent(id) {
      const component = this.components.find((comp) => comp.id === id)
      if (component) {
        component.enabled = false
      }
    },
    saveChanges() {
      if (window.location.pathname === '/transport-modes/profile') {
        const transportModes = useTransportModes()
        transportModes.updateComponents(this.components)
      }
      if (window.location.pathname === '/transport-modes/economic-performance') {
        const transportModes = useTransportModes()
        transportModes.updateComponentsEconomicPerformance(this.components)
      }
    },
  },
}
</script>

<style src="./styles.css"></style>
